import en from "../../data/localization/en.json";
import de from "../../data/localization/de.json";
import es from "../../data/localization/es.json";
import fr from "../../data/localization/fr.json";
import it from "../../data/localization/it.json";
import ja from "../../data/localization/ja.json";
import cs from "../../data/localization/cs.json";
import pl from "../../data/localization/pl.json";
import ru from "../../data/localization/ru.json";
import { I18n, Scope, TranslateOptions } from "i18n-js";
import { Event } from "event-system";
import { Language } from "./Language";
import { injectable } from "@launchtray/tsyringe-async";

@injectable()
export class Localization {
    private _locale: Language;
    public get locale(): Language {
        return this._locale;
    }
    public set locale(value: Language) {
        this._locale = value;
        this.i18n.locale = value;
        localStorage.setItem("Localization", value);
        this.localeChange.emit(value);
    }
    public localeChange: Event<Language> = new Event<Language>();
    private i18n: I18n;

    public constructor() {
        this.i18n = new I18n({ en, de, es, fr, it, ja, cs, pl, ru });
        const locale = localStorage.getItem("Localization");
        if (locale) {
            this._locale = locale as Language;
        }
        else {
            this.locale = Language.English;
        }
        this.i18n.defaultLocale = Language.English;
        this.i18n.locale = this._locale;
    }

    public getText(key: Scope, options?: TranslateOptions): string {
        return this.i18n.t(key, options);
    }
}
